import { render, staticRenderFns } from "./Left.vue?vue&type=template&id=50f6a3c2&scoped=true"
import script from "./Left.vue?vue&type=script&lang=js"
export * from "./Left.vue?vue&type=script&lang=js"
import style0 from "./Left.vue?vue&type=style&index=0&id=50f6a3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6a3c2",
  null
  
)

export default component.exports